module.exports = __webpack_public_path__ + "static/media/metamask.c8a516e6.svg";